const PERMISSIONS_PRODUCT_FEE_RULE_PAGE = {
  VIEW: 'product-fee-rule::index',
  CREATE: 'product-fee-rule::store',
  UPDATE: 'product-fee-rule::update',
  DELETE: 'product-fee-rule::delete',
} as const;

export default PERMISSIONS_PRODUCT_FEE_RULE_PAGE;
